import Stripe from 'stripe';
import { getFinalPriceAmountInCentsAfterCoupon } from './price-helpers';

type Props = {
  stripeInstance: Stripe;
  customerId: string;
  coupon?: Stripe.Coupon;
  subscriptionId: string;
  paymentMethodTypes?: string[];
  metadata: Stripe.MetadataParam | null;
};

export async function createPaymentIntentForEarlySubscriptionRenewal({
  stripeInstance,
  customerId,
  coupon,
  subscriptionId,
  paymentMethodTypes,
  metadata,
}: Props): Promise<Stripe.PaymentIntent> {
  const subscription = await stripeInstance.subscriptions.retrieve(subscriptionId);
  if (!subscription) {
    throw new Error('Subscription not found');
  }

  const priceItem = subscription.items.data[0]?.price;
  if (!priceItem) {
    throw new Error('Price item not found in subscription');
  }
  const amount = Math.floor(
    getFinalPriceAmountInCentsAfterCoupon({ price: priceItem, coupon }).finalAnnualAmountInCents,
  );

  return await stripeInstance.paymentIntents.create({
    amount,
    currency: priceItem.currency,
    customer: customerId,
    metadata: {
      ...metadata,
      renewalSubscriptionId: subscriptionId,
      shouldHandleEarlyRenewal: 'true',
    },
    payment_method_types: paymentMethodTypes,
  });
}
